import { render } from "./BarcodeUnpairScanRfid.vue?vue&type=template&id=face8d78&scoped=true"
import script from "./BarcodeUnpairScanRfid.vue?vue&type=script&lang=ts"
export * from "./BarcodeUnpairScanRfid.vue?vue&type=script&lang=ts"

import "./BarcodeUnpairScanRfid.vue?vue&type=style&index=0&id=face8d78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-face8d78"

export default script